import styled from 'styled-components'

type TextEditorWrapperProps = {
  hasError?: boolean
  borderLight?: boolean
}

export const TextEditorWrapper = styled.div<TextEditorWrapperProps>`
  width: 100%;

  .tox-tinymce {
    color: ${({ theme }) => theme.colors.greyishBrownFour};
    border: 1px solid
      ${({ theme, hasError, borderLight }) => {
        if (hasError) {
          return theme.colors.blush
        }

        if (borderLight) {
          return theme.colors.defaultGray
        }

        return theme.colors.warmGreyThree
      }};
    background-color: ${({ theme }) => theme.colors.white};
  }

  & > p {
    color: ${({ theme }) => theme.colors.blush};
    margin: ${({ theme }) => `${theme.spacings[1]} ${theme.spacings[4]}`};
  }
`
